<div class="add-announcements-container">
  <div class="web-announcement-form">
    <!-- Destinatarios -->
    <div class="web-announcement-form-left">
      <p
        class="paragrafo"
        *appIfRoles="profilesElegibleToManageEvents"
      >
        Lista de destinatários
      </p>
      <mat-card
        class="custom-card"
        *appIfRoles="profilesElegibleToManageEvents"
      >
        <label class="label-card">Para</label>
        <app-button-tree-dialog
          [text]="destSelectedText"
          [treeSectors]="treeRespProfiles"
          (outputData)="updateSelectedProfiles($event)"
        ></app-button-tree-dialog>

        <label class="label-card">Vincule turmas para este evento</label>
        <app-button-link-year-classrooms
          [classroomYear]="textclassroomYear"
          [idsClassrooms]="checkedIdsClassrooms"
          [text]="textButtonLinkYearClassrooms"
          (outputData)="updateCheckedClassroom($event)"
        ></app-button-link-year-classrooms>
      </mat-card>

      <div id="form-inputs" *ngIf="formVisible">
        <form class="add-announcement-form" [formGroup]="eventForm">
          <mat-form-field appearance="outline" class="input-events">
            <mat-label>Titulo*</mat-label>
            <input matInput formControlName="title" />
            <mat-error *ngIf="eventForm.get('title')?.hasError('required')"
              >Informe o titulo</mat-error
            >
          </mat-form-field>
          <mat-form-field appearance="outline" class="input-events">
            <mat-label>Mensagem*</mat-label>
            <textarea
              matInput
              formControlName="description"
              [value]="event?.description"
            ></textarea>
            <mat-error
              *ngIf="eventForm.get('description')?.hasError('required')"
              >Informe o texto</mat-error
            >
          </mat-form-field>
          <mat-form-field appearance="outline" class="input-events">
            <mat-label>Localização</mat-label>
            <input matInput formControlName="location" />
          </mat-form-field>

          <app-custom-date-time-picker
            [txtLabel]="'Data inicio*'"
            [txtPlaceholder]="'Data e Hora'"
            [inputDateStarted]="event?.startDate!"
            (dtTmSelected)="dtTmSelected('startDate', $event)"
            [clearField]="cleardtTmPicker"
          ></app-custom-date-time-picker>

          <app-custom-date-time-picker
            [txtLabel]="'Data final'"
            [txtPlaceholder]="'Data e Hora'"
            [inputDateStarted]="event?.endDate!"
            (dtTmSelected)="dtTmSelected('endDate', $event)"
            [clearField]="cleardtTmPicker"
          ></app-custom-date-time-picker>
        </form>
      </div>
    </div>

    <!-- Capa -->
    <div>
      <div id="capa-anexo" *ngIf="formVisible">
        <div class="container-capa">
          <p class="title-upload-file">Capa do evento</p>
          <p class="title-tamanho-imagem">
            Dimensão recomendada da capa: 450px de largura por 150px de altura.
          </p>
          <p>Tamanho máximo permitido da imagem: 10MB.</p>
          <app-file-uploader
            *appIfRoles="profilesElegibleToManageEvents"
            [text]="'Adicionar imagem de capa'"
            [type]="'background'"
            [initialFiles]="bgFiles"
            [filePathOldStructure]="backgroundFilePath"
            (currentFilesEmitter)="onCurrentBackgroundFileEmit($event)"
            (filesToDeleteEmitter)="onBackgroundFileToDeleteEmit($event)"
          >
          </app-file-uploader>
        </div>

        <!-- Anexos -->
        <div class="anexos-container">
          <p class="title-upload-file">Anexos</p>
          <p class="title-tamanho-imagem">
            Anexar apenas imagens e arquivos de extensão '.pdf'
          </p>
          <p class="title-tamanho-imagem">
            Tamanho máximo recomendado de cada anexo: 10MB.
          </p>
          <div [ngClass]="boxContour">
            <app-file-uploader
              *appIfRoles="profilesElegibleToManageEvents"
              [text]="'Adicionar novo anexo'"
              [type]="'attachment'"
              [initialFiles]="attachments"
              [filePathOldStructure]="attachmentsPath"
              (currentFilesEmitter)="onCurrentAttachmentsEmit($event)"
              (filesToDeleteEmitter)="onAttachmentsToDeleteEmit($event)"
            >
            </app-file-uploader>
          </div>
        </div>
        <!-- Anexos -->
      </div>
    </div>

    <div *appIfRoles="profilesElegibleToManageEvents">
      <div class="flex-btn">
        <app-button-spinner
          *ngIf="!isUpdate"
          buttonText="Limpar"
          (buttonClicked)="clearInputFields()"
          color="white"
          [disabled]="!isEnableCleanButton || saveInProgress"
        >
        </app-button-spinner>

        <app-button-spinner
          *ngIf="isUpdate"
          buttonText="Excluir"
          (buttonClicked)="deleteCurrentEvent()"
          color="white"
          [disabled]="saveInProgress"
        >
        </app-button-spinner>

        <app-button-spinner
          buttonText="{{ saveButtonText }}"
          [inProgressText]="inProgressText"
          [inProgress]="saveInProgress"
          (buttonClicked)="handleSaveButtonClicked()"
          color="blue"
          [disabled]="!this.eventForm.valid"
        >
        </app-button-spinner>
      </div>
    </div>
  </div>
</div>
